import { Field, ObjectType } from 'type-graphql'
import { ModelFamilyEnum } from './ModelFamilyEnum'

@ObjectType()
export class CheckVisionModelRateResult {
  /** The model identifier the guard checked — `args.model` when passed, else `openAiConfig.visionModel`. */
  @Field(() => String)
  configuredModel: string

  /** Whether an active `ModelRate` row exists for `configuredModel`. */
  @Field(() => Boolean)
  hasActiveRate: boolean

  /** The matched active rate's `family`, when one was found — absent on a miss. */
  @Field(() => ModelFamilyEnum, { nullable: true })
  family?: ModelFamilyEnum
}
